<template>
  <vue-recaptcha
    @verify="verifyMethod"
    @expired="expiredMethod"
    @render="renderMethod"
    @error="errorMethod"
    :loadRecaptchaScript="true"
    sitekey="6Leemv8cAAAAAIQnKHH4r1lVE_MCm6Hz9R4tRIgV"
  ></vue-recaptcha>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'

export default {
  components: {
    VueRecaptcha,
  },
  methods: {
    verifyMethod(event) {
      if (event) {       
        this.$emit('verifyMethod', true)
      }
    },
    //TODO precisamos tratar esses casos?
    expiredMethod(event) {
      this.$emit('expiredMethod', event)     
    },
    renderMethod(event) {
      this.$emit('renderMethod', event)     
    },
    errorMethod(event) {
      this.$emit('errorMethod', event)    
    },
  },
}
</script>

<style></style>
